module.exports = __webpack_public_path__ + "img/star2blue.f2e08475.png";